import React from 'react';
import PropTypes from 'prop-types';
import Sentry from 'Integrations/Sentry';
import isDev from 'Helpers/isDev';

export const UnexpectedMissingComponent = ({ message }) => {
  React.useEffect(() => {
    Sentry.createSentryErrorLog(new Error(message));
  }, []);

  if (isDev()) {
    throw new Error(message);
  }

  return null;
};

UnexpectedMissingComponent.propTypes = {
  message: PropTypes.string.isRequired,
};
